import { render, staticRenderFns } from "./backhome.vue?vue&type=template&id=0225b978"
import script from "./backhome.vue?vue&type=script&lang=ts"
export * from "./backhome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports